
import moment from "moment";

const convertDateToLocal = (responseDate) => {

  let returnString = '';

  let myDate = new Date(responseDate).toLocaleDateString('en-IN');
  // myDate is 12/28/2021

  let myTime = new Date(responseDate).toLocaleTimeString('en-IN');
  // myTime is 9:30:45 PM
  //console.log('myDate',myDate);
  //let dateformatted = moment(myDate,'MM/DD/YYYY').format('DD-MM-YYYY');
  let timeformatted = moment(myTime, "hh:mm A").format('HH:mm:ss');

  returnString = `${myDate} ${timeformatted}`;

  return returnString

}

const isNotEmptyData = (variableD) => {
  //check zero as string
  if (typeof variableD !== 'undefined' && variableD && variableD !== '0') {

    return true;
  } else {
    return false;
  }
}

const convertCallDurationToMin = (duration) => {

  // Hours, minutes and seconds
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = "";

  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;

  return ret;
}
const convertCallDurationToMinExcel = (duration) => {
  const totalSeconds = Number(duration);

  if (isNaN(totalSeconds)) return '="0:00"';

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const value = `${minutes}:${seconds.toString().padStart(2, "0")}`;

  return `="${value}"`;
};

const removeUnderscoreIPAC = (value) => {

  if (value === null) {
    return '';
  }

  if (value === 'null') {
    return ''
  }
  if (typeof value == 'number') {

    return ''
  }
  if (value === 'ना') {

    return ''
  }
  if (value.length === 0) {
    return value;
  }
  return value[0].toUpperCase() + value.replaceAll('_', ' ').substring(1);
}

const removeUnderscore = (value) => {

  if (value === null || value === undefined) {
    return '';
  }

  if (value === 'null') {
    return 'No reason'
  }
  if (typeof value == 'number') {

    return 'NA'
  }
  if (value === 'ना') {

    return 'NA'
  }
  if (value.length === 0) {
    return value;
  }
  return value[0].toUpperCase() + value.replaceAll('_', ' ').substring(1);
}


const ROLE_ACCESS = { SOBISCO: 1, INC: 2, IPAC: 3 };

const returnDateAndTime = (data) => {
  let finalDateTime = ""
  let resTime = data.response_time;
  const date = new Date();
  let IndianDateString = date.toLocaleDateString('en-IN');;

  let responseDate = new Date(resTime).toLocaleDateString('en-IN');
  let responseTime = new Date(resTime).toLocaleTimeString('en-IN');
  let timeformatted = moment(responseTime, "hh:mm").format('HH:mm A');
  if (IndianDateString === responseDate) {
    finalDateTime = "Today " + timeformatted
  }
  else {
    finalDateTime = getDateInString(responseDate) + " at " + timeformatted
  }
  return finalDateTime;
}

const getDateInString = (responseDate) => {
  let mon = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec"
  }
  if (responseDate && responseDate.split("/")[1]) {
    let dateVal = responseDate.split("/")[0]
    let monthVal = responseDate.split("/")[1];
    let yearVal = responseDate.split("/")[2]
    return dateVal + " " + mon[monthVal] + " " + yearVal
  }
}

export function fetchData(){
  const axios = require('axios');

let config = {
  method: 'get',
  maxBodyLength: Infinity,
  url: 'https://zet.quarkgen.ai/ICCS/zet/v1/analytics?startDate=2024-04-01T00:00:00.000Z&endDate=2024-10-14T23:59:00.000Z&page=1&limit=500',
  headers: { 
    'Accept': 'application/json, text/plain, */*', 
    'Accept-Language': 'en-US,en;q=0.9,hi;q=0.8', 
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyRGV0YWlscyI6eyJfaWQiOiI2NjBlYmNmZTQ0NDIwZjQzNmFhMDg1ZWMiLCJtb2JpbGVObyI6ODI0OTQ2ODAzNSwiZW1haWxJZCI6InNhaG9vLnR1c2hhcmthbnRhMjFAZ21haWwuY29tIiwidXNlckZ1bGxOYW1lIjoiVHVzYXIgU2Fob28iLCJpc05ld1VzZXIiOnRydWUsInBhZ2VzQWNjZXNzIjpbImFuYWx5dGljcyIsImluaXRpYXRlQ2FsbCJdLCJyb2xlIjoiYWRtaW4iLCJjcmVhdGVkQXQiOiIyMDI0LTA0LTA0VDE0OjQ1OjE4LjQ3MloiLCJ1cGRhdGVkQXQiOiIyMDI0LTA0LTA0VDE0OjQ1OjE4LjQ3MloiLCJfX3YiOjB9LCJpYXQiOjE3Mjg5MTI0MzIsImV4cCI6MTcyODkxNjAzMn0.oyGDuystMHfT4EjbPq3ARmvml00K_KqIklQV9TPfDGw', 
    'Connection': 'keep-alive', 
    'If-None-Match': 'W/"d0c09-o9rrA/5VdsIp9DldTnzIJRU1Z0U"', 
    'Referer': 'https://zet.quarkgen.ai/', 
    'Sec-Fetch-Dest': 'empty', 
    'Sec-Fetch-Mode': 'cors', 
    'Sec-Fetch-Site': 'same-origin', 
    'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36', 
    'sec-ch-ua': '"Google Chrome";v="129", "Not=A?Brand";v="8", "Chromium";v="129"', 
    'sec-ch-ua-mobile': '?0', 
    'sec-ch-ua-platform': '"macOS"'
  }
};

axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
})
.catch((error) => {
  console.log(error);
});

}
export { convertCallDurationToMinExcel,convertDateToLocal, isNotEmptyData, convertCallDurationToMin, removeUnderscore, ROLE_ACCESS, removeUnderscoreIPAC, returnDateAndTime }
